import { render } from "./ItemImport.vue?vue&type=template&id=f575210a"
import script from "./ItemImport.vue?vue&type=script&lang=js"
export * from "./ItemImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__